/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import {
  HomepageBannerNotification,
  HomepageHero,
  HomepageSolutions,
  HomepageTestimonials,
  HomepageIntegratedSolutions,
  HomepageLatestUpdate,
  HomepageCTA,
  HomepageAPI,
} from '../ui-templates';
import Loading from '@svb/api-loading-component/dist/components/index';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import MetaTags from '../core/MetaTags';
import '@svb/svbbranding/components/svb-ui-branding-homepage/dist/css/svb-base.css';
import AnnonTokenWrapper from '../core/AnnonTokenWrapper';
import { SVBErrorPageRenderer } from '../helpers/utilityFunctions';
// export const _react = React;
/**
 * HomePage
 * @param {object} props
 * @returns
 */
function HomePage(props) {
  /* eslint-disable */
  const { dattestid, testResponse, token } = props;
  /* eslint-enable */
  const [loading, setLoading] = useState(true);
  const [jsonContent, setjsonContent] = useState([]);
  const [ismounted, setIsmounted] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorStatusCode, setErrorStatusCode] = useState('');
  const [errorDefaultMessage, setErrorDefaultMessage] = useState(
    'It happens sometimes, you may refresh the page.',
  );
  const contentURL = process.env.REACT_APP_CONTENT_SERVER || '/api-content';
  const baseProxyUrl = `${contentURL}/portal-content?resourcePath=pages`;
  // @todo: Dharama please fix the content component as what we did in API core and also must accept then as well,
  // so you don't close it within the content component please
  // const token = localStorage.getItem('token');
  const contentFetch = async (url) => {
    return dattestid
      ? testResponse
      : await fetch(url, {
          headers: {
            Authorization: token,
            uuid: uuidv4(),
            audience: 'public'
          },
          credentials: 'omit',
        }).then((x) => {
          if (!x?.ok) {
            let error = new Error(x?.statusText);
            error.statusCode = x?.status || x?.code;
            throw error;
          }
          return x.json();
        });
  };
  const solveContents = (data) => {
    let pageRenderPre = [];

    Object.keys(data).map((key, i) => {
      let resourceContentUrl = baseProxyUrl + '&resourceName=' + data[key].content;
      try {
        /* istanbul ignore next */
        if (key === 'HomepageBannerNotification') {
          return pageRenderPre.push(
            <HomepageBannerNotification
              key={i}
              content={resourceContentUrl}
              visible={data[key].visible}
            />,
          );
        } else if (key === 'HomepageHeroSection') {
          return pageRenderPre.push(
            <HomepageHero
              key={i}
              content={resourceContentUrl}
              backgroundImg={data[key].backgroundImage}
            />,
          );
        } else if (key === 'HomepageSolutionsSection') {
          return pageRenderPre.push(
            <HomepageSolutions
              key={i}
              content={resourceContentUrl}
              backgroundImg={data[key].backgroundImage}
            />,
          );
        } else if (key === 'HomepageTestimonialsSection') {
          return pageRenderPre.push(
            <HomepageTestimonials
              key={i}
              content={resourceContentUrl}
              backgroundImg={data[key].backgroundImage}
            />,
          );
        } else if (key === 'HomepageApiSection') {
          return pageRenderPre.push(
            <HomepageAPI key={i} content={resourceContentUrl} title={data[key].title} />,
          );
        } else if (key === 'HomepageIntegratedSolutionsSection') {
          return pageRenderPre.push(
            <HomepageIntegratedSolutions
              key={i}
              content={resourceContentUrl}
              backgroundImg={data[key].backgroundImage}
            />,
          );
        } else if (key === 'HomepageLatestUpdate') {
          return pageRenderPre.push(<HomepageLatestUpdate key={i} content={resourceContentUrl} />);
        } else if (key === 'HomepageCtaBlock') {
          return pageRenderPre.push(<HomepageCTA key={i} content={resourceContentUrl} />);
        }
      } catch (error) {
        /* istanbul ignore next */
        return pageRenderPre.push(<>Error in rendering the component with key {key}</>);
      }
    });
    //   after finishing the order then we stop the loading
    setjsonContent(pageRenderPre);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  useEffect(() => {
    setIsmounted(true);
    contentFetch(baseProxyUrl + '&resourceName=homepage-template.json')
      .then((data) => {
        solveContents(data);
      })
      .catch((err) => {
        setIsError(true);
        if (err instanceof TypeError) {
          //network error eg: for no internet connection
          setErrorDefaultMessage('Network error occured. Please check your connection.');
          setErrorStatusCode(err?.statusCode);
        } else {
          setErrorStatusCode(err?.statusCode);
        }
        setLoading(false);
      });
  }, []);

  if (isError) {
    return (
      <SVBErrorPageRenderer
        errorStatusCode={errorStatusCode}
        enableButton={false}
        defaultErrorMessage={errorDefaultMessage}
      />
    );
  }

  return (
    <>
      {/*Generate metadata once component/template mounts */}
      {ismounted && (
        <MetaTags
          title={'Homepage'}
          sitename={'SVB Developer Portal'}
          description={
            'API banking from Silicon Valley Bank will give developers access to data and payment operations to enable direct integration with their own platforms and fintech apps of choice'
          }
          image={window.location.protocol + '//' + window.location.host + '/svb_fcb_logo_new.svg'}
          keywords={
            'svb, silicon valley bank, api, developer, portal, integration, fcb, first citizens'
          }
          type='website'
          author='Silicon Valley Bank'
        />
      )}

      {/*render page elements once data is available */}
      <div className='min-vh-100 pt-5 mt-2'>
        <div id='homepage'>
          {/* <RenderComp/> */}
          {loading ? (
            <Loading />
          ) : jsonContent.length ? (
            jsonContent
          ) : (
            'We are working to fix this page please try again later.'
          )}
        </div>
      </div>
    </>
  );
}
//Homepage component is wrapped with AnonToken higher order component to make token available even before this component loads
export default AnnonTokenWrapper(HomePage);
HomePage.propTypes = {
  dattestid: PropTypes.any,
  testResponse: PropTypes.any,
};
